document.addEventListener('DOMContentLoaded', function() {
    function moveAndSyncWidget() {
        var originalWidget = document.querySelector('.hulkapps_option.dd_render.option_type_id_886207');
        
        if (originalWidget) {
            var clonedWidget = originalWidget.cloneNode(true);
            clonedWidget.classList.add('custom-cloned-widget');

            var targetHolder = document.querySelector('.product__form__holder');
            
            if (targetHolder) {
                targetHolder.appendChild(clonedWidget);

                var originalDropdown = originalWidget.querySelector('select');
                var clonedDropdown = clonedWidget.querySelector('select');

                function syncDropdowns(srcDropdown, destDropdown) {
                    destDropdown.value = srcDropdown.value;
                    destDropdown.dispatchEvent(new Event('change', { bubbles: true }));
                }

                clonedDropdown.addEventListener('change', function() {
                    syncDropdowns(clonedDropdown, originalDropdown);
                });

                syncDropdowns(originalDropdown, clonedDropdown);
            }
        } else {
            setTimeout(moveAndSyncWidget, 500);
        }
    }

    moveAndSyncWidget();
});